// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import NorthernMarianaIslands from '../_raw/flag/icon_flag_northern_mariana_islands.png';

export default () => <img src={NorthernMarianaIslands} alt="NorthernMarianaIslands" />;
